import { BlockErrorMessage } from '../../../Block/BlockErrorMessage';
import { ButtonBase } from '../../../Button/ButtonBase';
import { FormListPassword } from '../../../Form/FormList/FormListPassword';
import { InnerButtonArea } from '../../../Layout/InnerLayout/InnerButtonArea';
import { InnerMargin } from '../../../Layout/InnerLayout/InnerMargin';
import { TableBody } from '../../../Table/TableBody';
import { TableTrFormLabel } from '../../../Table/TableTr/TableTrFromLabel';

import type { InvalidParam } from '../../../../types/InvalidParam';
import type { FC, ChangeEventHandler, FormEventHandler } from 'react';

export type PasswordResetChangeInvalidParam = InvalidParam & {
  name: 'newPassword';
};

export type PasswordResetChangeInvalidParams =
  PasswordResetChangeInvalidParam[];

export type PasswordResetChangeContentsProps = {
  invalidParams?: PasswordResetChangeInvalidParams;
  disableSubmitButton?: boolean;
  errorMessage?: string;
  eventHandlers?: {
    changePassword: ChangeEventHandler<HTMLInputElement>;
    submit: FormEventHandler<HTMLFormElement>;
  };
};

export const PasswordResetChangeContents: FC<
  PasswordResetChangeContentsProps
> = ({ invalidParams, disableSubmitButton, errorMessage, eventHandlers }) => {
  const newPasswordError = invalidParams?.find(
    (value) => value.name === 'newPassword',
  );

  return (
    <form method="post" onSubmit={eventHandlers?.submit}>
      <TableBody>
        <TableTrFormLabel
          id="password"
          required={true}
          errorMessage={
            newPasswordError?.reason ? newPasswordError?.reason : ''
          }
          title="新しいパスワード"
        >
          <FormListPassword onChange={eventHandlers?.changePassword} />
        </TableTrFormLabel>
      </TableBody>
      {errorMessage ? (
        <BlockErrorMessage>{errorMessage}</BlockErrorMessage>
      ) : (
        ''
      )}
      <InnerButtonArea>
        <InnerMargin align="center">
          <ButtonBase
            color="primary"
            width="extend"
            disable={disableSubmitButton === true}
          >
            変更する
          </ButtonBase>
        </InnerMargin>
      </InnerButtonArea>
    </form>
  );
};
